(function () {
  const initFaq = () => {
    const container = document.querySelector('.faq-section__list.no-js-hidden');
    if (!container) return;

    const toggles = container.querySelectorAll('[data-faq-toggle]');
    toggles.forEach((btn) => {
      btn.addEventListener('click', function () {
        const item = this.closest('.faq-section__item');
        const answer = item.querySelector('.faq-section__answer');
        const isOpen = item.classList.contains('active');

        if (isOpen) {
          item.classList.remove('active');
          btn.setAttribute('aria-expanded', 'false');
          answer.classList.remove('faq-section__answer--open');
          answer.addEventListener('transitionend', function onEnd() {
            answer.removeEventListener('transitionend', onEnd);
            answer.setAttribute('hidden', '');
          }, { once: true });
        } else {
          container.querySelectorAll('.faq-section__item.active').forEach((other) => {
            const otherAnswer = other.querySelector('.faq-section__answer');
            const otherBtn = other.querySelector('[data-faq-toggle]');
            other.classList.remove('active');
            if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
            otherAnswer.classList.remove('faq-section__answer--open');
            otherAnswer.addEventListener('transitionend', function onEnd() {
              otherAnswer.removeEventListener('transitionend', onEnd);
              otherAnswer.setAttribute('hidden', '');
            }, { once: true });
          });
          item.classList.add('active');
          answer.removeAttribute('hidden');
          btn.setAttribute('aria-expanded', 'true');
          requestAnimationFrame(() => {
            answer.classList.add('faq-section__answer--open');
          });
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFaq);
  } else {
    initFaq();
  }

  document.addEventListener('shopify:section:load', initFaq);
})();
